module.exports = __webpack_public_path__ + "img/forest-smc.7c93fd54.jpg";